import { FormGroup } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  RxFormBuilder,
  ReactiveFormConfig,
} from '@rxweb/reactive-form-validators';
import { SubSink } from 'subsink';

import { LoginViewEnum } from '../login-view.enum';

import { AuthService } from '@monorepo/ui/auth';
import { LoginService } from '../../services/login.service';
import { UserLogin } from '../../models';
import { NotifyAlertService } from '@monorepo/ui';

@Component({
  selector: 'signgaze-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  readonly subs = new SubSink();

  loginView: any = LoginViewEnum;
  userLoginForm: FormGroup;
  isSubmitted = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private loginService: LoginService,
    private notifyAlertService: NotifyAlertService,
    private rxFb: RxFormBuilder
  ) {
    this.setFormErrorMessage();
    this.createLoginForm();
  }

  ngOnInit(): void {
    this.navigateToDashboard();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private checkAndNavigateToDashboard(): void {
    this.subs.sink = this.authService.user.subscribe((user) => {
      if (user && this.authService.isEmailverified.value) {
        this.router.navigateByUrl('/dashboard');
      }
    });
  }

  private setFormErrorMessage(): void {
    ReactiveFormConfig.set({
      validationMessage: {
        password: 'Incorrect password',
      },
    });
  }

  public getPasswordInput(passwordInput: any): void {
    if (passwordInput.type === 'password') {
      passwordInput.type = 'text';
    } else {
      passwordInput.type = 'password';
    }
  }

  private createLoginForm(): void {
    this.userLoginForm = this.rxFb.formGroup(UserLogin);
  }

  public loginInWithEmailPassword(): void {
    this.isSubmitted = true;
    const email = this.userLoginForm.get('email').value;
    const password = this.userLoginForm.get('password').value;
    this.subs.sink = this.authService.emailLogin(email, password).subscribe({
      next: (credential: any): void => {
        if (credential.user.uid && credential.user.emailVerified) {
          this.checkAndNavigateToDashboard();
          this.isSubmitted = false;
        }
      },
      error: (error: any): void => {
        this.isSubmitted = false;
        this.notifyAlertService.error(error.message);
      },
    });
  }

  public changeLoginView(currentLoginView: LoginViewEnum): void {
    this.loginService.currentLoginView$.next(currentLoginView);
  }

  private navigateToDashboard(): void {
    this.subs.sink = this.authService.user.subscribe((user) => {
      if (user && this.authService.isEmailverified.value) {
        this.router.navigateByUrl('/dashboard');
      }
    });
  }
}
